<template lang="pug">
div.mylist--overlay(v-show="visibleForm" @click.self="hideAllForm")
  div.mylist--window
    ul.mylist--created(v-if="myLists.length != 0")
      li.mylist--created-item(v-for="myList in myLists" :key="myList.id" :class="myList.published ? 'public' : 'private'")
        input.mylist--created-value(
          type="checkbox"
          :id="`mylist_checkbox_${myList.id}`"
          :checked="myList.contain_target"
          @change="createOrDestroyElement(myList)"
          :disabled="myList.processing"
        )
        label.mylist--created-label(:for="`mylist_checkbox_${myList.id}`")
          div.mylist--created-icon(v-if="!myList.published")
            i.fa.font-awesome-icon.fa-lock
          div.mylist--created-name {{myList.name}}
          div.mylist--created-count {{myList.size}}
    div.mylist--empty(v-if="myLists.length == 0")
      div.mylist--empty-wrapper
        h3.mylist--empty-title <i class="fa fa-folder-open"></i>マイリスト機能
        div.mylist--empty-text 「経験あり」や「持ってる」とは別に、自由にテーマを設定してリスト登録することができます。
        div.mylist--empty-text
          | 作成したマイリストは公開/非公開を設定することができ、
          a(:href="`/friends/${currentUserId}/my_lists`" target="_blank" rel="noopener noreferrer") 公開プロフィールのマイリスト
          | で管理および閲覧が可能です。

    infinite-loading(spinner="waveDots" @infinite="infiniteLoad" :identifier="infiniteId" ref="infiniteLoading")
      var(slot="no-results")
      var(slot="no-more")

    form.mylist--form(@submit.prevent="createMyListAndElement")
      template(v-if="!visibleNewMyListForm")
        button.mylist--form-new(type="button" @click="showNewMyListForm")
          | 新しいマイリストを作成
        button.mylist--form-wishlist(
          v-if="showWishListButton"
          type="button"
          @click="toggleWishList"
          :disabled="wishListDisabled"
          :class="wishListAdded ? 'added' : 'add'"
        )
          | {{ wishListButtonText }}
      template(v-else)
        template(v-if="errorMessage")
          | {{ errorMessage }}
        div.mylist--form-item
          label.mylist--form-label リスト名
          input.mylist--form-value.form-control(v-model="newMyList.name" maxlength=50 required)
        div.mylist--form-item
          label.mylist--form-label 説明文
          textarea-autosize.mylist--form-value.form-control(v-model="newMyList.description" :max-height="113" maxlength="500")
        div.mylist--form-item
          label.mylist--form-label 公開設定
          select.mylist--form-value.form-control(v-model="newMyList.published")
            option(:value="0")
              | 非公開
            option(:value="1")
              | 公開
        div.mylist--form-submit
          button.mylist--form-update(type="submit")
            | この内容で作成

</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import axios from 'common/axios';

export default {
  components: { InfiniteLoading },
  props: {
    myListsFromParent: {
      type: Array,
      default: () => ([])
    },
    currentUserId: {
      type: Number,
      default: 0
    },
    myListType: {
      type: String,
      default: ''
    },
    listableId: {
      type: Number,
      default: 0
    },
    listableType: {
      type: String,
      default: ''
    },
    visibleForm: {
      type: Boolean,
      default: false
    },
    visibleNewMyListForm: {
      type: Boolean,
      default: false
    },
    wishListAdded: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      newMyList: {
        name: '',
        description: '',
        published: 1
      },
      page: 1,
      infiniteId: +new Date(),
      loading: false,
      errorMessage: '',
      wishListProcessing: false
    };
  },
  computed: {
    myLists: {
      get: function() {
        return this.myListsFromParent;
      },
      set: function(newMyLists) {
        this.$emit('set-my-lists', newMyLists);
      }
    },
    showWishListButton: function() {
      return this.listableType === 'Game';
    },
    wishListDisabled: function() {
      return !this.listableId || this.wishListProcessing;
    },
    wishListButtonText: function() {
      return this.wishListAdded ? 'ほしいものリストに追加済み' : 'ほしいものリストに追加する';
    },
    indexMylistPath: function() {
      return `/friends/${this.currentUserId}/my_lists`;
    },
    createMyListPath: function () {
      return '/mypage/my_lists';
    }
  },
  watch: {
    listableId: async function() {
      this.resetForm();
    }
  },
  mounted: function() {
    this.infiniteLoad(this.$refs.infiniteLoading.stateChanger);
  },
  methods: {
    createMyListElementPath: function (myListId) {
      return `/mypage/my_lists/${myListId}/elements`;
    },
    destroyMyListElementPath: function (myListId) {
      return `/mypage/my_lists/${myListId}/elements/destroy_by_params`;
    },
    hideAllForm: function() {
      this.$emit('hide-all-form');
    },
    showNewMyListForm: function() {
      this.$emit('show-new-my-list-form');
    },
    infiniteLoad: function($state) {
      if (this.listableId) {
        axios.get(this.indexMylistPath, {
          params: {
            page: this.page,
            listable_id: this.listableId,
            listable_type: this.listableType
          }
        }).then(({ data }) => {
          if (data.my_lists.length) {
            this.page == 1 ? this.myLists = data.my_lists : this.myLists.push(...data.my_lists);
            this.page += 1;
            $state.loaded();
            if (data.last_page) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        });
      }
    },
    createMyListAndElement: async function () {
      try {
        this.errorMessage = '';
        let data = {
          my_list: {
            name: this.newMyList.name,
            description: this.newMyList.description,
            published: this.newMyList.published,
            list_type: this.myListType
          }
        };
        let res = await axios.post(this.createMyListPath, data);
        await axios.post(
          this.createMyListElementPath(res.data.my_list_id),
          {
            my_list_id: res.data.my_list_id,
            listable_id: this.listableId,
            listable_type: this.listableType
          }
        );
        this.onCreateMyListAndElement();
        this.$emit('load-added-my-lists', this.listableId);
      } catch (e) {
        this.errorMessage = e.response.data.message;
      }
    },
    createMyListElement: async function (data) {
      let myList = this.myLists.find((myList) => myList.id === data.my_list_id);
      this.$set(myList, 'processing', true);
      await axios.post(this.createMyListElementPath(data.my_list_id), data);
      this.$set(myList, 'contain_target', true);
      this.$set(myList, 'size', myList.size + 1);
      this.$set(myList, 'processing', false);
      this.$emit('load-added-my-lists', this.listableId);
    },
    destroyMyListElement: async function (data) {
      let myList = this.myLists.find((myList) => myList.id === data.my_list_id);
      this.$set(myList, 'processing', true);
      await axios.delete(this.destroyMyListElementPath(data.my_list_id), {
        params: {
          listable_id: data.listable_id,
          listable_type: data.listable_type
        }
      });
      this.$set(myList, 'contain_target', false);
      this.$set(myList, 'size', myList.size - 1);
      this.$set(myList, 'processing', false);
      this.$emit('load-added-my-lists', this.listableId);
    },
    onCreateMyListAndElement: function() {
      this.hideAllForm();
      this.newMyList = {
        name: '',
        description: '',
        published: 1
      };
      this.resetForm();
      this.infiniteLoad(this.$refs.infiniteLoading.stateChanger);
    },
    createOrDestroyElement: function(myList) {
      if(myList.contain_target) {
        this.destroyMyListElement({
          my_list_id: myList.id,
          listable_id: this.listableId,
          listable_type: this.listableType
        });
      } else {
        this.createMyListElement({
          my_list_id: myList.id,
          listable_id: this.listableId,
          listable_type: this.listableType
        });
      }
    },
    resetForm: function() {
      this.myLists = [];
      this.page = 1;
      this.infiniteId++;
      this.wishListProcessing = false;
    },
    addToWishList: async function() {
      if (this.wishListDisabled) {
        return;
      }
      this.wishListProcessing = true;
      try {
        await axios.post('/market/wish_list_elements', {
          listable_id: this.listableId,
          listable_type: this.listableType
        });
        this.$emit('wish-list-added', this.listableId);
      } finally {
        this.wishListProcessing = false;
      }
    },
    removeFromWishList: async function() {
      if (this.wishListDisabled) {
        return;
      }
      this.wishListProcessing = true;
      try {
        await axios.delete('/market/wish_list_elements/destroy_by_params', {
          params: {
            listable_id: this.listableId,
            listable_type: this.listableType
          }
        });
        this.$emit('wish-list-removed', this.listableId);
      } finally {
        this.wishListProcessing = false;
      }
    },
    toggleWishList: function() {
      if (this.wishListAdded) {
        this.removeFromWishList();
      } else {
        this.addToWishList();
      }
    }
  }
};
</script>
